const $ = require("jquery");
require("../../components/ui-components/reviewsCarousel"); // shared reviews block carousel (requires slick itself)
require("../../components/ui-components/subcatCarousel");  // M7: mobile business-type card scroller, shared by both CAT pages

// C19: reserve the tallest Ask Simply tab panel's height so the navy card
// doesn't resize while switching tabs. Covers every page loading this entry;
// Medical Clinics loads medicalClinicsPage instead, so it misses the reserve.
function initReserveTallestTabPanel() {
    const wraps = document.querySelectorAll(".ask-simply__tabs .tabs-panels");

    wraps.forEach(function (wrap) {
        const panels = Array.from(wrap.querySelectorAll(".tabs-panel"));
        if (!panels.length) {
            return;
        }

        let measuring = false;

        function reserveTallestPanel() {
            // The ResizeObserver below watches `wrap`, and this function changes
            // wrap's own height, so guard against re-entering mid-measurement.
            if (measuring) {
                return;
            }
            measuring = true;
            wrap.style.minHeight = "";
            // C19 was measured at 1280 and is a desktop/tablet concern. Below $mob the
            // panels differ by hundreds of pixels, so reserving the tallest leaves a
            // large empty area on the shorter ones. Let mobile size naturally.
            if (window.matchMedia("(max-width: 767px)").matches) {
                wrap.style.minHeight = "";
                measuring = false;
                return;
            }
            let tallest = 0;
            panels.forEach(function (panel) {
                const wasHidden = panel.hasAttribute("hidden");
                // An inactive panel has no vertical padding of its own: the
                // .tabs-panel.active rule supplies it (16px top and bottom). Measuring
                // without that class under-reports every inactive panel by 32px, which
                // is enough for the tallest panel to lose and the reserve to be too
                // short, so add the active classes for the duration of the measurement.
                const wasInactive = !panel.classList.contains("active");
                if (wasHidden) {
                    panel.removeAttribute("hidden");
                }
                if (wasInactive) {
                    panel.classList.add("active", "in");
                }
                if (wasHidden) {
                    // Without an explicit width an absolutely positioned panel is
                    // shrink-to-fit, so its text lays out at max-content width and
                    // reports a shorter height than it will actually occupy.
                    // .tabs-panels is position:relative, so 100% is its content width.
                    panel.style.cssText =
                        "position:absolute;top:0;left:0;width:100%;visibility:hidden";
                }
                tallest = Math.max(tallest, panel.offsetHeight);
                if (wasHidden) {
                    panel.style.cssText = "";
                }
                if (wasInactive) {
                    panel.classList.remove("active", "in");
                }
                if (wasHidden) {
                    panel.setAttribute("hidden", "until-found");
                }
            });
            wrap.style.minHeight = tallest + "px";
            measuring = false;
        }

        reserveTallestPanel();
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(reserveTallestPanel);
        }
        if (window.ResizeObserver) {
            new ResizeObserver(reserveTallestPanel).observe(wrap);
        }
    });
}


$(function () {
    initReserveTallestTabPanel();
});
